<div class="container dark">
    <h1 class="dark">Détails</h1>
    <form [formGroup]="opportunityCreationForm" class="full-width">
        <div class="mat-form-field custom field-md" *ngIf="isAdminOrManager()">
            <mat-checkbox formControlName="exonerated" (change)="setVatExonerated($event)">Client exonéré de TVA</mat-checkbox>
        </div>
        <div class="clear-row"></div>
    </form>
</div>
